import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Popover, message } from "antd";
import { find } from 'lodash';
import dayjs from 'dayjs';

import * as constants from '../constants';
import {
    deleteDossierFile, updateDossierFile, createDossierFile, loadDossierFiles, openLinkedDossierFile
} from '../actions';
import EditDossierFileForm from './EditDossierFileForm';
import NewDossierFileForm from './NewDossierFileForm';

import core from '../../core';
import uistate from '../../uistate';
import common from '../../../common';

const { GenericTable } = core;


class DossierFilesGrid extends Component {

    state = {
        addFormVisible: false,
        editFormVisible: false,
        currentEditEntity: {},
    };

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'DossierFilesGrid', key);
    }

    //#region Grid button handlers
    onRefreshFiles = () => {
        this.props.loadDossierFiles(this.props.idDossier);
    }

    onAddClicked = (e) => {
        this.setState({
            currentEditEntity: {},
            addFormVisible: true,
        });
    }
    onDeleteClicked = (id) => {
        this.props.deleteDossierFile(this.props.idDossier, id)
            .then(() => {
                this.props.loadDossierFiles(this.props.idDossier);
            });
    }
    onEditClicked = (id) => {
        const editentity = find(this.props.files, { 'idDossierLinkedFile': id });
        this.setState({
            currentEditEntity: editentity,
            editFormVisible: true,
        });
    }

    downloadLinkedFile = (id) => {
        this.props.openLinkedDossierFile(id);
    }
    //#endregion    

    //#region Form handlers

    handleCancelForm = (e) => {
        this.setState({
            addFormVisible: false,
            editFormVisible: false,
            currentEditEntity: {},
        });
    }
    handleEntityAdd = (values) => {
        message.info(this.label('SavingFileMessage'), 5);
        this.props.createDossierFile(this.props.idDossier, values)
            .then(() => {
                this.props.loadDossierFiles(this.props.idDossier);
            });
        this.setState({
            addFormVisible: false,
            currentEditEntity: {},
        });
    }

    handleEntityEdit = (values) => {
        console.log(values);
        this.props.updateDossierFile(this.props.idDossier, values)
            .then(() => {
                this.props.loadDossierFiles(this.props.idDossier);
            });
        this.setState({
            editFormVisible: false,
            currentEditEntity: {},
        });
    }


    //#endregion

    render() {
        const readOnly = this.props.readOnly ? this.props.readOnly : false;
        const columns = [{
            title: this.label('Filename'),
            dataIndex: 'filename',
            key: 'filename',
            sorter: (a, b) => ('' + a.filename).localeCompare(b.filename),
        }, {
            title: this.label('Description'),
            dataIndex: 'description',
            key: 'description',
            sorter: (a, b) => ('' + a.description).localeCompare(b.description),
        }, {
            title: this.label('CreatedOn'),
            dataIndex: 'createdOn',
            key: 'createdOn',
            sorter: (a, b) => {
                if (dayjs(a.createdOn).isBefore(dayjs(b.createdOn))) {
                    return -1;
                }
                return 1;
            },
            render: (text, record) => (
                <span>
                    {dayjs.utc(record.createdOn).format('DD-MM-YYYY')}
                </span>
            )
        }];
        switch (this.props.dossiertype){
            case common.DOSSIER_TYPES.ProcessingActivity:
                columns.push(
                    {
                        title: this.label('FileTypeName'),
                        dataIndex: 'fileTypeName',
                        key: 'fileTypeName',
                        sorter: (a, b) => ('' + a.fileTypeName).localeCompare(b.fileTypeName),
                    }
                );
                columns.push(
                    {
                        title: this.label('Date'),
                        dataIndex: 'date',
                        key: 'date',
                        sorter: (a, b) => {
                            if (dayjs(a.date).isBefore(dayjs(b.createdOn))) {
                                return -1;
                            }
                            return 1;
                        },
                        render: (text, record) => (
                            <span>
                                {record.date ? dayjs.utc(record.date).format('DD-MM-YYYY') : ''}
                            </span>
                        )
                    }
                );
                break;
            case common.DOSSIER_TYPES.Incident:
            default:  
        }

        return (
            <div className='dossier'>
                <GenericTable aligntop multiline columns={columns} data={this.props.files} keyfield='idDossierLinkedFile' itemName={this.label('File')} pagesize={20}
                    onAdd={this.onAddClicked}
                    readOnly={readOnly}
                    onDelete={this.onDeleteClicked}
                    onEdit={this.onEditClicked}
                    onView={this.downloadLinkedFile}
                    onRefresh={this.onRefreshFiles}
                    onDoubleClick={this.onEditClicked} />

                <Modal title={this.label("AddModalTitleForm")} width='80%' destroyOnHidden={true}
                    open={this.state.addFormVisible}
                    footer={null}
                    onCancel={this.handleCancelForm}
                >
                    <NewDossierFileForm dossiertype={this.props.dossiertype} onCancel={this.handleCancelForm} onSave={this.handleEntityAdd} />
                </Modal>

                <Modal title={this.label("EditModalTitleForm")} width='80%' destroyOnHidden={true}
                    open={this.state.editFormVisible}
                    footer={null}
                    onCancel={this.handleCancelForm}
                >
                    <EditDossierFileForm dossiertype={this.props.dossiertype} downloadLinkedFile={this.downloadLinkedFile} datacontext={this.state.currentEditEntity} onCancel={this.handleCancelForm} onSave={this.handleEntityEdit} />
                </Modal>

            </div>
        );
    }
}

DossierFilesGrid.defaultProps = {
    dossiertype: -1
}

function mapStateToProps(state) {
    return {
        files: state[constants.NAME].files,
        labels: uistate.selectors.uiLabels(state),
    };
}

export default connect(mapStateToProps,
    {
        deleteDossierFile, updateDossierFile, createDossierFile, loadDossierFiles, openLinkedDossierFile
    })(DossierFilesGrid);  